import { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { CommentReply } from '../components/CommentReply';
import { EditBox } from '../components/EditBox';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../redux/store';
import {
  postLoungeCommentReply,
  removeUserLounge,
  wholikeCommentReply,
  likeCommentReply,
} from '../redux/lounges/slice';
import { selectLounges } from '../redux/lounges/selectors';
import Modal from 'react-modal';
import { useForm } from 'react-hook-form';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { fetchLounges, postLoungeFlag } from '../redux/lounges/slice';
import { createModuleDeclaration } from 'typescript';
import { LikeCommentReply } from '../components/LikeCommentReply';

import axios, { AxiosResponse } from 'axios';
import { GET_BASE_URL } from '../constants/apiEndpoints';
import { GET_BASE_URL_IMAGE } from '../constants/apiEndpoints';
import { COMPLETIONSTATEMENT_TYPES } from '@babel/types';
import { format } from 'path';
import { getUserMembershipBadges } from '../utils/userMembershipBadges';

type CommentListPropsType = {
  chatId: any;
  cmt: any;
  replyShow: boolean;
  stickerData: any;
};
type FormData = {
  ReasonForReport: string;
  LoungeId: number;
  Type: string;
};
export const CommentList: React.FC<CommentListPropsType> = ({
  chatId,
  cmt,
  replyShow,
  stickerData,
}) => {
  const dispatch = useAppDispatch();
  let navigate = useNavigate();
  const {
    register,
    setValue,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FormData>();

  const [showReply, SetShowReply] = useState<any | string>(replyShow);
  const [replyTargetUserName, setReplyTargetUserName] = useState<any | string>(
    cmt.commentuser?.user_name
  );
  const [replyTargetReplyId, setReplyTargetReplyId] = useState<any | null>(null);
  const [replyTargetText, setReplyTargetText] = useState<any | string>(
    cmt.chat_reply_msg
  );
  const [editbox, SetEditBox] = useState<any | string>(false);

  function converDate(datevalue: any) {
    const date = new Date(datevalue);
    const formattedDate = date.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    });
    return formattedDate;
  }
  function converTime(datevalue: any) {
    const date = new Date(datevalue);
    const formattedDate = date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
    });
    return formattedDate;
  }
  const token = localStorage.getItem('token');
  const loginuserid = localStorage.getItem('user_id');
  //console.log(token);
  const showReplyIcon = (
    targetUserName?: string,
    targetReplyId?: any,
    targetText?: string
  ) => {
    if (token == null) {
      navigate('/disneyland/login');
    } else {
      setReplyTargetUserName(targetUserName || cmt.commentuser?.user_name);
      setReplyTargetReplyId(targetReplyId ?? null);
      setReplyTargetText(targetText || cmt.chat_reply_msg);
      SetShowReply(true);
    }
  };
  const closeReplyBox = () => {
    SetShowReply(false);
    setReplyTargetUserName(cmt.commentuser?.user_name);
    setReplyTargetReplyId(null);
    setReplyTargetText(cmt.chat_reply_msg);
  };
  const showEditBox = () => {
    SetEditBox(!editbox);
  };

  const [modalIsOpen, setIsOpen] = useState(false);
  let subtitle: any;
  function openModal() {
    setIsOpen(true);
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = '#f00';
  }

  function closeModal() {
    setIsOpen(false);
  }

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      width: '100%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      background: '#F5F5F5',
      transform: 'translate(-50%, -50%)',
    },
  };

  let sortType: any = null;
  //let LoungeId: any = null;
  let currentPage: any = null;
  let searchValue: any = null;
  const [Type, setFlagType] = useState<string>('R');
  const [LoungeId, setLoungeId] = useState<number | any>('');

  const { items, status, sortByTime } = useSelector(selectLounges);
  const [shortByTime, setShortByTime] = useState<any | string>(
    localStorage.getItem('shortByTime')
  );
  const [Notify, setIsNotify] = useState<any | string>();

  const myGift = (Id: any) => {
    if (token == null) {
      navigate('/disneyland/login');
    } else {
      setIsOpen(true);
      setLoungeId(Id);
    }
  };

  useEffect(() => {
    sortByTime != '' && setShortByTime(sortByTime);
  }, [sortByTime]);

  useEffect(() => {
    setValue('Type', Type);
  }, [Type]);

  useEffect(() => {
    setValue('LoungeId', LoungeId);
  }, [LoungeId]);

  const onSubmit = (data: any) => {
    dispatch<any>(postLoungeFlag(data)).then((res: any) => {
      // Notify(toast(res.payload.data[0].error));
    });
  };

  const [RemoveType, setRemoveType] = useState<any | string>('C');
  const onRemove = (ban_chat_id: any) => {
    dispatch<any>(removeUserLounge({ ban_chat_id, RemoveType })).then(
      (res: any) => {
        window.location.reload();
      }
    );
  };

  const [likeuserlist, setLikeUserList] = useState<any | string>(false);
  const [likeuserdata, setLikeUserData] = useState<any | string>([]);

  const [formatedMsg, setFormatedMsg] = useState(cmt.chat_reply_msg);
  const membershipBadges = getUserMembershipBadges(cmt.commentuser, items);

  useEffect(() => {

    var domParser = new DOMParser();
    var doc = domParser.parseFromString(formatedMsg, 'text/html');
    var msg = doc.body.innerHTML;
    let replacemsg = msg.match(/@(\w+)/g)?.map(match => match.substring(1));
    async function convert()
    {
      for(const val of replacemsg ?? []) {
        if(val.length > 0) {
          let response = await axios.get(GET_BASE_URL + '/api/v1/getUserId?name=' + val)
          if(response.data.data.length > 0) {
            let id = response.data.data[0].id;
            let htmltext = "<a href='/disneyland/user/" + id + "/mypost'>@" + val + "</a>";
            msg = msg.replace('@' + val, htmltext);
          }
        } 
      }
      doc.body.innerHTML = msg;
      setFormatedMsg(msg)
    }
    convert();
  }, [cmt.chat_reply_msg]);
  
  // const formattedMessage = async (message: string) => {
  //   var domParser = new DOMParser();
  //   var doc = domParser.parseFromString(message, 'text/html');
  //   var msg = doc.body.innerText;
  //   let replacemsg = msg.match(/@(\w+)/g)?.map(match => match.substring(1));
    
  //   {
  //       await replacemsg?.map((val) => {
  //       val.length > 0 && axios
  //         .get(GET_BASE_URL + '/api/v1/getUser?name=' + val)
  //         .then((response: any) => {
  //           if(response.data.data.length > 0) {
  //             let id = response.data.data[0].id;
  //             let htmltext = "<a href='/../../user/" + id + "/mypost'>" + val + "</a>";
  //             msg = msg.replace('@' + val, htmltext);
  //             console.log('aaaaaaaa', msg)
  //           }
  //       });

  //     })
  //   }
    
    // setFormatedMsg(msg)
    // return msg;
    // var links = doc.querySelectorAll('.mention');
    // links.forEach(function (linkTag: any) {
    //   var aTag = document.createElement('a');
    //   aTag.href = `../../user/${linkTag.dataset.id}/mypost`;

    //   aTag.style.color = '#0000EE';
    //   aTag.style.marginRight = '3px';
    //   aTag.innerHTML = linkTag.innerHTML;
    //   linkTag.parentNode.replaceChild(aTag, linkTag);
    // });
    // console.log('aaaaaa', msgtext)
    // return "<p>asdf</p>";

  return (
    <>
      <>
        <div
          className={`mw-comment-thread ${
            showReply || cmt.commentsreply?.length ? 'mw-comment-thread--connected' : ''
          }`}
        >
          <div className='comm-bo mw-comment-card d-flex flex-row' key={cmt.chat_id}>
            <div className='small-c mw-comment-avatar'>
              <Link to={`/disneyland/user/${cmt.commentuser?.user_id}/mypost`}>
                <img
                  src={
                    GET_BASE_URL_IMAGE +
                    '/disneyland/images/thumbs/' +
                    cmt.commentuser.image
                  }
                  className='com-imggg'
                  alt={`${cmt.commentuser?.user_name || 'MouseWaiter'} avatar`}
                />
              </Link>
            </div>
            {/* <ToastContainer autoClose={3000} /> */}
            <div className='comm-c mw-comment-main d-flex'>
              <div className='commentlist mw-comment-message'>
                <div
                  dangerouslySetInnerHTML={{
                    __html: formatedMsg
                      .replace('<p>', '<span>')
                      .replace('</p>', '</span>')
                      .replace('<br>', ''),
                  }}
                />
              </div>

              <div className='mw-comment-footer'>
                <div className='mw-comment-author-stack'>
                  <div className='mw-comment-author-row'>
                    <Link
                      className='mw-comment-author-name'
                      to={`/disneyland/user/${cmt.commentuser?.user_id}/mypost`}
                    >
                      {cmt.commentuser?.user_name}
                    </Link>
                    {membershipBadges.map((badge) => (
                      <span
                        key={badge.key}
                        className={`mw-comment-badge ${badge.className}`}
                        title={badge.title}
                      >
                        {badge.label}
                      </span>
                    ))}
                  </div>
                  <div className='com-tt mw-comment-stats'>
                    <span>{cmt.commentuser?.rank}</span>
                    <span>#{cmt.commentuser?.position}</span>
                    <span>{converDate(cmt?.chat_reply_date)}</span>
                  </div>
                </div>

                <div className='co-l mw-comment-actions'>
                  <button type='button' onClick={() => myGift(cmt.chat_reply_id)}>
                    Flag
                  </button>

                    <LikeCommentReply
                      likecount={cmt.no_of_likes}
                      chat_id={cmt.chat_id}
                      comment_id={cmt.chat_reply_id}
                      reply_id={''}
                      commnet_userid={cmt.commentuser.user_id}
                      type={'C'}
                      page={'DL'}
                    />

                  <button
                    type='button'
                    onClick={() => showReplyIcon(cmt.commentuser?.user_name)}
                  >
                    Reply
                  </button>

                {/*  {likeuserlist == true ? (
                  <div className='pro-card-s'>
                    <div className='card'>
                      <div className='card-header text-center'>
                        <h6>MouseWaiters who Liked this:</h6>
                      </div>

                      {likeuserdata.map((product: any) => {
                        return (
                          <div
                            className='pro-img text-center'
                            style={{ display: 'flex', padding: '0.5rem' }}
                          >
                            <img
                              src={
                                'https://mousewait.xyz/disneyland/chat_images/' +
                                product.user?.image
                              }
                              style={{
                                height: '50px',
                                width: '50px',
                                borderRadius: '50%',
                              }}
                              alt='image'
                            />
                            <h6 style={{ padding: '1rem' }}>
                              {product?.user?.user_name}
                            </h6>
                          </div>
                        );
                      })} 
                    </div>
                  </div>
                ) : (
                  <></>
                )} */}

                <>
                  {cmt.commentuser.user_id == loginuserid ? (
                    <>
                      <button type='button' onClick={showEditBox}>Edit</button>
                      
                      <button type='button' onClick={() => {
                        if (window.confirm('Are You Sure?'))
                          onRemove(cmt.chat_reply_id)
                        }}
                      >
                        Delete
                      </button>
                    </>
                  ) : (
                    <></>
                  )}
                </>
                </div>
              </div>
            </div>
          </div>

          <Modal
            isOpen={modalIsOpen}
            onAfterOpen={afterOpenModal}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel='Example Modal'
          >
            <form
              className='space-y-6'
              onSubmit={handleSubmit(onSubmit)}
              method='POST'
            >
              <div className='row'>
                <div className='box-t-1'>
                  <h6
                    style={{ fontSize: '1rm', fontWeight: 400, color: 'red' }}
                  >
                    Report
                  </h6>
                  <div className='close-p' onClick={closeModal}>
                    <i className='fa fa-close my-b' />
                  </div>
                  <div className='boxwidth'>
                    <div className='box-ttt'>
                      {/* <label for="story" class="w-50 m-auto justify-content-start">Tell us your story</label> */}
                      <textarea
                        rows={3}
                        cols={60}
                        placeholder='write reason for reporting'
                        {...register('ReasonForReport')}
                      />
                      <input
                        type='hidden'
                        /*    setValue={Type} */
                        {...register('Type')}
                      />
                      <input
                        type='hidden'
                        /* setValue={LoungeId} */
                        {...register('LoungeId')}
                      />
                      <div className='mw-post text-center'>
                        <input className='MW-btn' type='Submit' value='Post' />
                        {/* {isLoading == true ? (
                          <input
                            className='MW-btn'
                            type='Submit'
                            value='Posting'
                          />
                        ) 
                        : (
                          <input
                            className='MW-btn'
                            type='Submit'
                            value='Post'
                          />
                        )} */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </Modal>

          <EditBox
            replyData={''}
            id={''}
            chatId={cmt.chat_id}
            chat_reply_id={cmt.chat_reply_id}
            chat_reply_msg={cmt.chat_reply_msg}
            stickerData={stickerData}
            editbox={editbox}
            type={'C'}
          />

          <CommentReply
            replyData={cmt.commentsreply || []}
            replyShow={showReply}
            chatId={cmt.chat_id}
            chat_reply_id={cmt.chat_reply_id}
            stickerData={stickerData}
            parentCommentUserName={cmt.commentuser?.user_name}
            parentCommentText={cmt.chat_reply_msg}
            replyTargetUserName={replyTargetUserName}
            replyTargetReplyId={replyTargetReplyId}
            replyTargetText={replyTargetText}
            onRequestReply={showReplyIcon}
            onCancelReply={closeReplyBox}
            onReplySubmitted={closeReplyBox}
          />
        </div>
      </>
    </>
  );
};
